import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faEnvelope,
  faPhone,
  faPrint,
  faMailBulk,
  
} from '@fortawesome/free-solid-svg-icons';
import {  Link} from "react-router-dom";

class FooterNew extends Component {
  render() {
    return (
      
      <footer className="text-center text-lg-start text-white" style={{ backgroundColor: '#217CA3', padding:"8px"}}>
        

        <section className="">
          <div className="container text-left text-md-start mt-2">
            <div className="row mt-3">
              <div className="col-md-3 col-m-4 col-m-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold">ABOUT</h6>
                
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://nhp.mowr.gov.in" target="_blank"rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}} >
                   NHP
                  </a>
                  </span>
                </p>
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
    <Link to="/pm" style={{ color: 'inherit' }}>
      Project Team
    </Link>
  </span>
</p>
              </div>

              <div className="col-md-2 col-m-2 col-m-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold">USEFUL LINKS</h6>
              
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://bhuvan.nrsc.gov.in" target="_blank" rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                    Bhuvan
                  </a>
                  </span>
                </p>
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://www.nrsc.gov.in" target="_blank" rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                   NRSC
                  </a>
                  </span>
                </p>
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <Link to="/trainingnew/courses" style={{ color: 'inherit' }}  >
                    NHP Training
                  </Link>
                  </span>
                </p>
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://www.isro.gov.in" target="_blank" rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                    ISRO
                  </a>
                  </span>
                </p>
              </div>
             

              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold">OTHER SERVICES</h6>
               
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://bhuvan-wbis.nrsc.gov.in/" target="_blank" rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                    WBIS
                  </a>
                  </span>
                </p>
                <p style={{ color: "#c4dfe6", fontWeight: "400", fontFamily: "Calibri (Body)" }}>
  <span style={{ textDecoration: 'none' }}>
                  <a href="https://bhuvan-app1.nrsc.gov.in/twris/twris.php" target="_blank" rel="noopener noreferrer" style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                    TWRIS
                  </a>
                  </span>
                </p>
                
              </div>
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold">FEEDBACK</h6>
          
                <p>
                  <a  href="mailto:water@nrsc.gov.in"   style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}
> Submit Feedback</a></p>
                  
                        
                
              </div>

              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold">Contact</h6>
                
                <p style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                   Project Director,  NHP
                </p>
                <p style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                  <FontAwesomeIcon icon={faEnvelope} className="me-3" />
                   <span> National Remote Sensing Centre (NRSC), Balanagar
Hyderabad, 500037 </span>

                </p>
                <p style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                  <FontAwesomeIcon icon={faEnvelope} className="me-3" />
                  <span> Email</span>: water@nrsc.gov.in
                </p>
                <p style={{color:"#c4dfe6",fontweight:"500",fontFamily:"Calibri (Body)"}}>
                  <FontAwesomeIcon icon={faPhone} className="me-3" />
                   + 040 2388 4251
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="text-center p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)', color :"#c4dfe6" }}>
          © HYDROSiGHT: NRSC-ISRO  Last Update: 24-Oct-2024
          
        </div>
      </footer>
    
    );
  }
}

export default FooterNew;
